import React from 'react';
import {
	ToothLog,
	useDeleteToothLogMutation,
} from '../../../../../graphql/graphql';
import ScrollableDataTable from '../../../../Base/Components/ScrollableDataTable/ScrollableDataTable';
import { ITableColumn } from '../../../../../Models/Table/ITableColumn';
import useTranslation from '../../../../../Hooks/useTranslation';
import { DENT_HISTORY_TYPE } from '../../../Helpers/history/historyType';
import { getHistoryValue } from '../../../Helpers/history/getHistoryValue';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../Hooks/useNotification.hook';

interface Props {
	logs?: ToothLog[];
	reload: () => void;
}

const DENTHistoryItemLogs = ({ logs, reload }: Props) => {
	const { t } = useTranslation();
	const [deleteToothLog] = useDeleteToothLogMutation();
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	if (!logs?.length) {
		return null;
	}

	const handleDelete = async (id: string) => {
		const response = await deleteToothLog({
			where: { id },
		});

		if ('error' in response) {
			displayGQLError(response);
		} else {
			showNotificationSuccess({
				content: 'patientTreatment.meddiDENT.history.deleteSuccess',
			});
			reload();
		}
	};

	const columns: ITableColumn[] = [
		{
			key: 'toothNumber',
			title: 'patientTreatment.meddiDENT.history.form.toothNumber',
			renderItem: (log: ToothLog) => <span>{log.tooth.number}</span>,
		},
		{
			key: 'type',
			title: 'patientTreatment.meddiDENT.history.form.type',
			renderItem: (log: ToothLog) => (
				<span>
					{t(
						DENT_HISTORY_TYPE[log.type as keyof typeof DENT_HISTORY_TYPE] || '',
					)}
				</span>
			),
		},
		{
			key: 'value',
			title: 'patientTreatment.meddiDENT.history.form.value',
			renderItem: (log: ToothLog) => (
				<span>{t(getHistoryValue({ type: log.type, value: log.data }))}</span>
			),
		},
		{
			key: 'actions',
			renderItem: (log: ToothLog) => (
				<LinkButton
					title={'base.shared.delete'}
					theme={Theme.RED}
					onClick={() => handleDelete(log.id)}
				/>
			),
		},
	];

	return (
		<ScrollableDataTable
			columns={columns}
			rows={logs}
			firstColumnFixed={false}
		/>
	);
};

export default DENTHistoryItemLogs;
